import React, { ReactNode } from 'react';
import { DocumentFile } from 'components/icons';
import { classes } from 'utils/components';

import styles from './DownloadCraftButton.module.scss';

type Props = {
  disabled?: boolean;
  onClick?: () => void;
  children?: ReactNode;
};

const DownloadCraftButton: React.FC<Props> = ({ disabled, onClick, children }) => {
  return (
    <div
      className={classes(styles.button, disabled ? styles.disabled : '')}
      onClick={!disabled ? onClick : undefined}
    >
      <DocumentFile />
      <span>{children}</span>
    </div>
  );
};

export default DownloadCraftButton;
